/**
 * Start the lazy page chunk for the current URL immediately.
 * ProtectedRoute used to wait for /auth/me before importing DashboardPage,
 * which made restored /dashboard tabs feel stuck on a spinner.
 */
const path = typeof window !== "undefined" ? window.location.pathname || "" : "";

if (path.startsWith("/dashboard")) {
  import("@/pages/DashboardPage");
} else if (path.startsWith("/transaction/")) {
  import("@/pages/TransactionPage");
} else if (path.startsWith("/templates/")) {
  import("@/pages/TemplateEditPage");
} else if (path.startsWith("/templates")) {
  import("@/pages/TemplatesPage");
} else if (path.startsWith("/unified")) {
  import("@/pages/UnifiedViewPage");
} else if (path.startsWith("/settings")) {
  import("@/pages/SettingsPage");
} else if (path.startsWith("/admin")) {
  import("@/pages/AdminPage");
} else if (path.startsWith("/tools")) {
  import("@/pages/ToolsPage");
} else if (path.startsWith("/learn")) {
  import("@/pages/TutorialHubPage");
} else if (path.startsWith("/broker")) {
  import("@/pages/BrokerDashboardPage");
} else if (path.startsWith("/tc-dashboard")) {
  import("@/pages/TCDashboardPage");
} else if (path.startsWith("/tc-performance")) {
  import("@/pages/TCPerformancePage");
} else if (path.startsWith("/tc-invite/")) {
  import("@/pages/TCInvitePage");
} else if (path.startsWith("/invite/")) {
  import("@/pages/InvitePage");
} else if (path.startsWith("/shared/")) {
  import("@/pages/SharedTransactionPage");
} else if (path.startsWith("/unsubscribe/")) {
  import("@/pages/UnsubscribePage");
}
